import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ActionDefaultPagePage} from './action-default-page.page';
import {DefaultAppPageModule} from "../../../../components/common/defaut-application-page/default-app-page.module";
import {ContentModule} from "../../../../shared/directives/content.module";
import {ButtonModule} from "../../component/button/button.module";
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {ActionDefaultModule} from '../../component/action-default/action-default.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        DefaultAppPageModule,
        ContentModule,
        ButtonModule,
        LoadingModule,
        ActionDefaultModule,
    ],
    declarations: [ActionDefaultPagePage],
    exports: [ActionDefaultPagePage]
})
export class ActionDefaultPagePageModule {
}
